var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft4Lengeh11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 30",
    style: {
      enableBackground: "new 0 0 76 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.1,15.4h-2.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S48.4,15.4,48.1,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.6,11.4 47.6,18.4 51.1,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,15.7H7.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S10.1,15.7,9.9,15.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.4,11.7 9.4,18.7 12.9,15.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,30H0V0h76V30z M1,29h74V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,25.3H42.5V4.4H54V25.3z M43.5,24.4H53v-19h-9.5V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,15.4h-2.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S31.8,15.4,31.5,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.2,18.4 29.2,11.4 25.7,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,15.7h-2.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.7c0.3,0,0.5,0.2,0.5,0.5S68.6,15.7,68.3,15.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66,18.7 66,11.7 62.5,15.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,25.3H22.9V4.4h11.5V25.3z M23.9,24.4h9.5v-19h-9.5V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C39,29.8,38.7,30,38.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C19.7,29.8,19.5,30,19.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C57.8,29.8,57.6,30,57.3,30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.8,
    y: 4.3,
    width: 18.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 4.3,
    width: 18.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 25.2,
    width: 18.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 25.2,
    width: 18.5,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft4Lengeh11);
export default __webpack_public_path__ + "static/media/joft_4_lengeh_11.887ddb870b29af208698f9373209f3e4.svg";
export { ForwardRef as ReactComponent };